export var APP_STATE;
(function (APP_STATE) {
    APP_STATE["FORM"] = "form";
    APP_STATE["TABLE"] = "table";
    APP_STATE["PAYBOOK"] = "paybook";
    APP_STATE["APPROVED"] = "approved";
    APP_STATE["CANCELLED"] = "cancelled";
    APP_STATE["BANK_TRANSFER"] = "banktransfer";
    APP_STATE["CONSENTS"] = "consents";
    APP_STATE["CERTIFICATES"] = "certificates";
    APP_STATE["CERTIFICATE_SUCCESS"] = "certificate_success";
    APP_STATE["CANCEL_BOOKING"] = "cancel_booking";
    APP_STATE["CMS"] = "cms";
})(APP_STATE || (APP_STATE = {}));
export var EntitiesEnum;
(function (EntitiesEnum) {
    EntitiesEnum["COURSE_TIMESPANS"] = "course_timespans";
    EntitiesEnum["COURSES"] = "courses";
    EntitiesEnum["PLACES"] = "places";
    EntitiesEnum["TAGS"] = "tags";
    EntitiesEnum["PRICES"] = "prices";
    EntitiesEnum["FORM_FIELDS"] = "form_fields";
    EntitiesEnum["FORM_GROUPS"] = "form_groups";
    EntitiesEnum["FORM_ITEMS"] = "form_items";
    EntitiesEnum["USERS"] = "users";
    EntitiesEnum["COURSE_APPOINTMENTS"] = "course_appointments";
    EntitiesEnum["COUNTRIES"] = "countries";
    EntitiesEnum["SALUTATIONS"] = "salutations";
    EntitiesEnum["CONSENT"] = "consents";
    EntitiesEnum["BILLS"] = "bills";
    EntitiesEnum["BILL_POSITIONS"] = "bill_positions";
    EntitiesEnum["PAYMENT_GATEWAY_CONFIGS"] = "payment_gateway_configs";
    EntitiesEnum["BANKS"] = "banks";
    EntitiesEnum["PAYMENTS"] = "payments";
    EntitiesEnum["OUTGOING_MESSAGES"] = "outgoing_messages";
    EntitiesEnum["SCHEDULING_TIME_RANGES"] = "scheduling_time_ranges";
    EntitiesEnum["QUANTITY_STEPS"] = "course_timespan_quantity_steps";
    EntitiesEnum["COURSE_PARTICIPANTS"] = "course_participants";
    EntitiesEnum["PERSONAL_DATA"] = "personal_data";
    EntitiesEnum["SELECT_OPTIONS"] = "extra_column_dropdown_options";
    EntitiesEnum["DISCOUNTS"] = "discounts";
})(EntitiesEnum || (EntitiesEnum = {}));
export var ECourseColumns;
(function (ECourseColumns) {
    ECourseColumns["TIMESPAN"] = "timespan";
    ECourseColumns["COURSES"] = "courses";
    ECourseColumns["COURSE"] = "course";
    ECourseColumns["PLACES"] = "places";
    ECourseColumns["PLACE"] = "place";
    ECourseColumns["FROM"] = "from";
    ECourseColumns["TRAINER"] = "trainer";
    ECourseColumns["TO"] = "to";
    ECourseColumns["PRICE"] = "price";
    ECourseColumns["INFO"] = "info";
    ECourseColumns["APPOINTMENTS"] = "appointments";
    ECourseColumns["APPOINTMENT_LIST"] = "appointmentlist";
    ECourseColumns["REMAINING"] = "remaining";
    ECourseColumns["DESCRIPTION"] = "infolink";
    ECourseColumns["BOOKLINK"] = "booklink";
})(ECourseColumns || (ECourseColumns = {}));
export var filterableColumns = ['courses', 'places', 'months', "search"];
